import { render, staticRenderFns } from "./ds-permission.vue?vue&type=template&id=b2678c7c&scoped=true&"
import script from "./ds-permission.vue?vue&type=script&lang=ts&"
export * from "./ds-permission.vue?vue&type=script&lang=ts&"
import style0 from "./ds-permission.vue?vue&type=style&index=0&id=b2678c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2678c7c",
  null
  
)

export default component.exports